import React, { useState } from "react";
import {
  Modal,
  Box,
  TextField,
  Button,
  Stack,
  Typography,
} from "@mui/material";

export default function NoteModal({ open, onClose, onSave }) {
  const [note, setNote] = useState("");

  const handleSave = () => {
    onSave(note);
    setNote("");
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        dir="rtl"
        sx={{
          backgroundColor: "white",
          padding: 3,
          borderRadius: 2,
          width: 400,
          mx: "auto",
          mt: "20vh",
          boxShadow: 3,
          textAlign: "center",
        }}
      >
        <Typography variant="h6" gutterBottom>
          إضافة ملاحظة
        </Typography>

        <Typography variant="body2" color="text.secondary" mb={1}>
          الرجاء إدخال ملاحظة توضيحية حول سبب الإجراء.
        </Typography>

        <TextField
          label="الملاحظة"
          placeholder="أدخل ملاحظتك هنا..."
          fullWidth
          multiline
          rows={3}
          value={note}
          onChange={(e) => setNote(e.target.value)}
          sx={{
            mb: 2,
            "& .MuiInputBase-input": {
              textAlign: "center",
              direction: "rtl",
            },
            "& .MuiInputLabel-root": {
              right: 0,
              left: "auto",
              transformOrigin: "top right",
            },
          }}
        />

        <Stack direction="row" justifyContent="center" spacing={1} mt={1}>
          <Button variant="outlined" color="secondary" onClick={onClose}>
            إلغاء
          </Button>
          <Button variant="contained" color="primary" onClick={handleSave}>
            حفظ
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
}
